import Button from '../../common/buttons/Button';
import React, { useContext, useState } from 'react';
import parse from 'html-react-parser';

import { ProfileContext } from '../../../contexts/ProfileContext';
import { useGraphQL } from '../../../hooks/useGraphQL';

type Props = {
    text: string;
    title?: string;
    previewText?: string;
    audioOpened?: boolean;
    setAudioOpened: (a: boolean) => void;
    audio?: any;
    emptyImage?: boolean;
    snow?: boolean | null;
    currentStep?: number;
};

export default function ZdarTaskText({
    text,
    previewText,
    audio,
    audioOpened,
    setAudioOpened,
    title,
    emptyImage,
    snow,
    currentStep,
}: Props) {
    const [open, setOpen] = useState(false);
    const { setSnow } = useGraphQL();
    const [sentStatus, setSentStatus] = useState(false);
    const { availableGame } = useContext(ProfileContext);

    const onSetSnow = (status: boolean) => {
        setSentStatus(true);
        setSnow(status, availableGame?.token ?? null);
    };
    const formattedText = text.replace('*playIcon*', `<img src='/common/audio-play.gif' alt="play" width=30 />`);
    const formattedPreviewText = previewText?.replace(
        '*playIcon*',
        `<img src='/common/audio-play.gif' alt="play" width=30 />`,
    );
    const showImageInText = () => {
        if (emptyImage) {
            return (
                <div className="image-in-text-wrapper">
                    <div className="task-title-audio-icon">
                        {audio && !audioOpened && (
                            <img
                                src="/common/audio-play.gif"
                                alt="play"
                                onClick={() => setAudioOpened(true)}
                                width={34}
                            />
                        )}
                    </div>
                    <div className="task-title-audio-icon">
                        {audio && !audioOpened && <div className="task-title-placeholder" />}
                    </div>
                </div>
            );
        }
        return <React.Fragment />;
    };
    if (currentStep === 1 && snow === null && setSnow !== undefined && !sentStatus) {
        return (
            <React.Fragment>
                <div className="zdar-cipher-text-wrapper">
                    <div className="zdar-cipher-text">{text && parse(formattedText)}</div>
                </div>
                <div className="zdar-cipher-text-wrapper">
                    <div className="zdar-cipher-text-snow-title">Je dnes na chodnících sníh?</div>
                    <div className="zdar-cipher-text-snow-buttons">
                        <Button onClick={() => onSetSnow(true)} className="primary-button">
                            {'Ano'}
                        </Button>
                        <Button onClick={() => onSetSnow(false)} className="primary-button">
                            {'Ne'}
                        </Button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    if (!previewText) {
        return (
            <div className={title ? 'task-text' : 'task-text task-text--standalone'}>
                {showImageInText()}
                {parse(formattedText)}
            </div>
        );
    } else {
        return (
            <div className={title ? 'task-text' : 'task-text task-text--standalone'}>
                {open && (
                    <div className="zdar-task-full">
                        {showImageInText()}
                        {parse(formattedText)}
                    </div>
                )}
                {!open && (
                    <div className="zdar-task-preview">
                        {showImageInText()}
                        {parse(formattedPreviewText + '&hellip;')}
                        <Button onClick={() => setOpen(true)} className="primary-button">
                            Zobrazit celý text
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}
